import { defaultClient as ApolloClient } from "../main";
import { ogStoreClient } from "../main";

import Client from "shopify-buy";

import {
  GET_CATEGORY,
  GET_CATEGORY_VALUE,
  GET_USERS,
  USER_DELETE,
  USER_MERGE,
  SIGN_IN_USER,
  VENDOR_QRY,
  VENDOR_MERGE,
  VENDOR_DELETE,
  GET_CURRENT_USER,
  GET_NEW_TOKEN
} from "../components/constants/graphql";
import router from "../router.js";

const client = Client.buildClient({
  domain: "olympian-guru-store.myshopify.com",
  storefrontAccessToken: "1a0efe88df38ff95a2bfc0b7176d4c10"
});

export default {
  allCategory: ({ commit }) => {
    commit("setLoading", true);
    //use ApolloClient to fire graphql query
    ApolloClient.query({
      query: GET_CATEGORY
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setCategory", data.allCategory);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  allCategoryValue: ({ commit }) => {
    commit("setLoading", true);
    //use ApolloClient to fire graphql query
    ApolloClient.query({
      query: GET_CATEGORY_VALUE
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setCategoryValue", data.allCategoryValue);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  /********************************************************/
  /****************DRILLS START****************************/

  allUser: ({ commit }, payload) => {
    commit("setLoading", true);
    ApolloClient.query({
      query: GET_USERS,
      variables: payload
    })
      .then(({ data }) => {
        commit("setUsersList", data.allUser);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  userDelete: ({ state, commit }, payload) => {
    ApolloClient.mutate({
      mutation: USER_DELETE,
      variables: payload
      //      update: (client, { data: { userDelete } }) => {}
    })
      //.then(({ data }) => {
      .then(() => {
        const index = state.usersList.edges.findIndex(
          users => users.node.userId === payload.userId
        );
        const usersList = {
          edges: [
            ...state.usersList.edges.slice(0, index),
            ...state.usersList.edges.slice(index + 1)
          ]
        };
        commit("setUsersList", usersList);
      })
      .catch(err => {
        console.error(err);
      });
  },
  userMerge: ({ state, commit }, payload) => {
    ApolloClient.mutate({
      mutation: USER_MERGE,
      variables: payload,
      update: (client, { data: { userMerge } }) => {} // eslint-disable-line
    })
      .then(({ data }) => {
        if (payload.userId == 0) {
          const usersList = {
            edges: [...state.usersList.edges, data.userMerge]
          };
          commit("setUsersList", usersList);
        } else {
          const index = state.usersList.edges.findIndex(
            user => user.node.userId === data.userMerge.node.userId
          );
          const usersList = {
            edges: [
              ...state.usersList.edges.slice(0, index),
              data.userMerge,
              ...state.usersList.edges.slice(index + 1)
            ]
          };
          commit("setUsersList", usersList);
        }
      })
      .catch(err => {
        console.error(err);
      });
  },
  /********************************************************/
  /***********AUTHENTICATION BLOCK*************************/

  signInUser: ({ commit }, payload) => {
    commit("clearError");
    commit("setLoading", true);
    localStorage.setItem("graphqlError", "");
    // clear token to prevent any errors if malformed.
    //localStorage.setItem('token',"");
    ApolloClient.mutate({
      mutation: SIGN_IN_USER,
      variables: payload,
      update: (client, { data: { userDetails } }) => {} // eslint-disable-line
    })
      .then(({ data }) => {
        localStorage.setItem("token", data.signInUser.userDetails.accessToken);
        localStorage.setItem("userId", data.signInUser.userDetails.userId);
        localStorage.setItem(
          "refresh_token",
          data.signInUser.userDetails.refreshToken
        );
        // to make sure created method is run in main.js( we run getCurrentUsser), reload page
        router.go();
        //router.push('/lib/home_lib');
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        commit("setError", err);
        console.error(err);
      });
  },

  signUpUser: ({ commit }, payload) => {
    commit("clearError");
    commit("setLoading", true);
    // clear token to prevent any errors if malformed.

    ApolloClient.mutate({
      mutation: USER_MERGE,
      variables: payload
      // update: (client, { data: { userDetails } }) => {}
    })
      .then(() => {
        //localStorage.setItem('token',data.signUpUser.userDetails.accessToken);
        //localStorage.setItem('userId',data.signInUser.userDetails.userId);
        //localStorage.setItem('refresh_token',data.signUpUser.userDetails.refreshToken);
        // to make sure created method is run in main.js( we run getCurrentUsser), reload page
        //router.go();
        router.push("/auth/signin").catch(err => {
          commit("setError", err);
        });
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        commit("setError", err);
        console.error(err);
      });
  },

  signoutUser: async ({ commit }) => {
    commit("clearError");
    commit("clearUser");

    // remove token in localStorage
    localStorage.setItem("token", "");
    localStorage.setItem("userId", "");
    localStorage.setItem("refresh_token", "");

    // end session
    // console.dir(ApolloClient);
    await ApolloClient.resetStore();
    // redirect home - kick users out of private pages ( i.e. profile)
    router.push("/auth/signin").catch(err => {
      commit("setError", err);
      console.error(err);
    });
  },

  getCurrentUser: ({ commit }, payload) => {
    commit("clearError");
    commit("setLoading", true);
    ApolloClient.mutate({
      mutation: GET_CURRENT_USER,
      variables: payload,
      update: (client, { data: { getCurrentUser } }) => {}  // eslint-disable-line
    })
      .then(({ data }) => {
        // Add user data to state
        commit("setUser", data.getCurrentUser);
        commit("setLoading", false);
      })
      .catch(err => {     // eslint-disable-line
        //commit('setUser', null);
        //localStorage.setItem('userId','');
        commit("setLoading", false);
        commit("setError", err);
        console.error(err);
      });
  },

  getCurrentUserDetails: ({ commit }, payload) => {
    commit("setLoading", true);
    ApolloClient.query({
      query: GET_USERS,
      variables: payload
    })
      .then(({ data }) => {
        commit("setUser", data.allUser.edges[0].node);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  getNewToken: ({ commit }, payload) => {
    // remove token in localStorage
    commit("clearError");
    localStorage.setItem("graphqlError", "");
    commit("setLoading", true);
    ApolloClient.mutate({
      mutation: GET_NEW_TOKEN,
      variables: payload,
      update: (client, { data: { getNewToken } }) => {} // eslint-disable-line
    })
      .then(({ data }) => {
        // Add user data to state
        //commit('setUser', data.getCurrentUser);
        localStorage.setItem("token", data.getNewAccessToken.newAccessToken);
        localStorage.setItem("graphqlError", "");
        commit("setLoading", false);
      })
      .catch(err => {
        //commit('setUser', null);
        //localStorage.setItem('userId','');
        commit("setLoading", false);
        commit("setError", err);
        console.error(err);
      });
  },

  /****** Shop component ***************/
  allProducts: ({ commit }, payload) => { // eslint-disable-line
    commit("setLoading", true);
    client.product
      .fetchAll()
      .then(products => {
        commit("setProducts", products);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  /* cart */

  addProductToCart: ({ state, commit, dispatch }, payload) => {
    const cartItem = state.cart.find(
      item => item.variantId === payload.computedDataVariantId
    );

    const productVariant = payload.product.variants.find(
      item => item.id === payload.computedDataVariantId
    );

    const productCart = {
      variantId: payload.computedDataVariantId,
      id: payload.id,
      quantity: parseInt(payload.productQuantity, 10),
      productVariant: productVariant
    };

    if (!cartItem) {
      commit("pushProductToCart", productCart);
    } else {
      commit("incrementItemQuantityCart", productCart);
    }

    const payloadCart = {
      cart: state.cart,
      destination: "cart"
    };
    dispatch("SET_TO_LOCALSTORAGE", payloadCart);
  },

  deleteProductFromCart({ commit, state, dispatch }, id) {
    commit("deleteProductFromCart", id);
    const payloadCart = {
      cart: state.cart,
      destination: "cart"
    };
    dispatch("SET_TO_LOCALSTORAGE", payloadCart);
  },

  CHECKOUT({ state }) {
    client.checkout.create().then(checkout => {
      let lineItemsToAdd = [];
      state.cart.forEach(cartEl => {
        let newNode = [
          {
            variantId: cartEl.variantId,
            quantity: cartEl.quantity,
            customAttributes: [{ key: "MyKey", value: "MyValue" }]
          }
        ];
        lineItemsToAdd = lineItemsToAdd.concat(newNode);
      });
      client.checkout
        .addLineItems(checkout.id, lineItemsToAdd)
        .then(checkout => {
          window.open(checkout.webUrl, "_self");
        });
    });
  },

  SET_TO_LOCALSTORAGE({ state }, payloadCart) {  // eslint-disable-line
    let valueString = JSON.stringify(payloadCart.cart);
    localStorage.setItem(payloadCart.destination, valueString);
  },

  allVendors: ({ commit }) => {
    commit("setLoading", true);
    // use ApolloClient to fire graphql query
    ogStoreClient
      .query({
        query: VENDOR_QRY
      })
      .then(({ data }) => {
        // Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setVendorsList", data.allVendor);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },
  vendorMerge: ({ state, commit }, payload) => {
    ogStoreClient
      .mutate({
        mutation: VENDOR_MERGE,
        variables: payload,
        update: (client, { data: { vendorMerge } }) => {} // eslint-disable-line
      })
      .then(({ data }) => {
        if (payload.vendorSeqno == 0) {
          const vendorsList = {
            edges: [...state.vendorsList.edges, data.vendorMerge]
          };

          commit("setVendorsList", vendorsList);
        } else {
          const index = state.vendorsList.edges.findIndex(
            vendor =>
              vendor.node.vendorSeqno === data.vendorMerge.node.vendorSeqno
          );

          const vendorsList = {
            edges: [
              ...state.vendorsList.edges.slice(0, index),
              data.vendorMerge,
              ...state.vendorsList.edges.slice(index + 1)
            ]
          };

          commit("setVendorsList", vendorsList);
        }
      })
      .catch(err => {
        console.error(err);
      });
  },

  vendorDelete: ({ state, commit }, payload) => {
    ogStoreClient
      .mutate({
        mutation: VENDOR_DELETE,
        variables: payload
      })
      .then(() => {
        const index = state.vendorsList.edges.findIndex(
          vendor => vendor.node.vendorSeqno === payload.vendorSeqno
        );

        const vendorsList = {
          edges: [
            ...state.vendorsList.edges.slice(0, index),
            ...state.vendorsList.edges.slice(index + 1)
          ]
        };

        commit("setVendorsList", vendorsList);
      })
      .catch(err => {
        console.error(err);
      });
  }
};
